import { EnergyPassportDetailsTable } from "@/features/energy-passport/ui/detail-tables/energy-passport-details-table.tsx"
import { useEnergyPassportDetailsStore } from "@/features/energy-passport/ui/detail-tables/model/store.ts"

export function EnergyPassportGasTable() {
  // Store
  const { gas } = useEnergyPassportDetailsStore()

  return <EnergyPassportDetailsTable title="Энергетических баланс газа" storeItem={gas} />
}
